import { colors } from '../../../../theme/colors';
import {
  Box,
  styled,
  Paper,
  CircularProgress,
  Button,
  TableCell,
} from "@mui/material";

export const CandidateReportsWrapper = styled(Box)({
  borderRadius: "16px",
  "& .first_heading": {
    fontWeight: "bold",
    color: colors.primary,
  },
  "& .MuiTableCell-head": {
    color: "#fff !important",
    fontSize: "13.5px",
    fontWeight: 600,
    backgroundColor: colors.primary,
    backgroundImage: `linear-gradient(135deg, ${colors.primary} 0%, ${colors.secondary} 100%)`,
    whiteSpace: "nowrap",
    letterSpacing: "0.3px",
    padding: "14px 16px",
  },
  "& .table-header-cell": {
    textAlign: "left",
    minWidth: "145px",
    color: "#fff",
    fontSize: "13.5px",
    fontWeight: 600,
    backgroundColor: colors.primary,
    backgroundImage: `linear-gradient(135deg, ${colors.primary} 0%, ${colors.secondary} 100%)`,
    whiteSpace: "nowrap",
    letterSpacing: "0.3px",
    padding: "14px 16px",
  },
  "& .MuiTableBody-root .MuiTableRow-root": {
    transition: "background-color 0.15s ease",
    "&:hover": {
      backgroundColor: colors.sidebarHover,
    },
  },
  "& .score-badge": {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 700,
    fontSize: "13px",
    color: colors.primary,
    backgroundColor: colors.primaryLight,
    borderRadius: "6px",
    padding: "3px 10px",
    minWidth: "48px",
  },
  "& .download-cell": {
    textAlign: "center",
    minWidth: "150px",
  },
  "& .download-icon": {
    marginRight: "5px",
  },
  "& .candidates-primary-details": {
    display: "flex",
    gap: 10,
    alignItems: "center",
    "& > div > p": {
      fontSize: "0.875rem",
      "&:nth-of-type(2)": {
        color: "#919EAB",
      },
    },
  },

  "& .report-search-box": {
    flex: 1,
    minWidth: "200px",
    marginRight: "1.5rem",
  },
  "& .custom-label": {
    color: colors.primary,
    fontWeight: 600,
  },

  "& .select-box": {
    color: colors.primary,
    "& fieldset": {
      borderColor: colors.primary,
    },
    "& .MuiSelect-select": {
      paddingLeft: "1rem",
      textAlign: "left",
    },
  },
  "& .custom-scrollbar": {
    marginBottom: "20px",
    overflowY: "hidden",
    overflowX: "auto",
    "&::-webkit-scrollbar": {
      width: "8px",
      height: "8px",
    },
    "&::-webkit-scrollbar-track": {
      background: "lightgray",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: colors.primary,
      borderRadius: "10px",
      border: "2px solid lightgray",
    },
  },
  "& .download_button": {
    backgroundColor: colors.primary,
    color: "#ffffff !important",
    textTransform: "capitalize",
    borderRadius: "8px",
    padding: "6px 16px",
    fontSize: "0.85rem",
    fontWeight: 600,
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: colors.primaryHover,
      boxShadow: `0 4px 12px ${colors.primary}44`,
      transform: "translateY(-1px)",
    },
    "&.Mui-disabled": {
      backgroundColor: colors.primary,
      color: "white",
      opacity: 0.8,
    },
  },
  "& .btn": {
    backgroundColor: colors.primary,
    color: "#fff",
    borderRadius: "8px",
    textTransform: "capitalize",
    padding: "8px 20px",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: colors.primaryHover,
      boxShadow: `0 4px 12px ${colors.primary}44`,
    },
  },
  "& .pagination-container": {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "20px",
  },
  "& .error-container": {
    backgroundColor: "#f8d7da",
    color: "#721c24",
    padding: "16px",
    borderRadius: "8px",
  },
  "& .no-records": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    marginTop: "20vh",
    gap: 1,
    fontSize: "18px",
    color: colors.primary,
    fontWeight: "bold",
  },
  "& .no-records-icon": {
    fontSize: "50px",
    color: colors.primary,
  },
  "& .candidate-details-box": {
    display: "block",
    flexDirection: "column",
  },
  "& .reports-container": {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
    background: "white",
    padding: "20px",
    borderRadius: "8px",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
  },
  "& .report-header": {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottom: "2px solid #ddd",
    paddingBottom: "10px",
  },
  "& .report-title": {
    fontSize: "18px",
    fontWeight: "bold",
    color: "#333",
  },
  "& .filter-section": {
    display: "flex",
    gap: "10px",
  },
  "& .table-container": {
    marginTop: "20px",
  },
  "& .table": {
    width: "100%",
    borderCollapse: "collapse",
  },
  "& .table th, & .table td": {
    padding: "12px",
    border: "1px solid #ddd",
    textAlign: "left",
  },
  "& .table th": {
    backgroundColor: colors.primary,
    color: "white",
  },
  "& .table tr:nth-child(even)": {
    backgroundColor: "#f2f2f2",
  },
  "& .action-buttons": {
    display: "flex",
    gap: "10px",
  },
  "& .edit-button": {
    backgroundColor: "#ffc107",
    color: "white",
  },
  "& .delete-button": {
    backgroundColor: "#dc3545",
    color: "white",
  },
  "& .export-button": {
    backgroundColor: "#28a745",
    color: "white",
    padding: "10px",
    borderRadius: "5px",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#218838",
    },
  },
});

export const StyledTableCell = styled(TableCell)({
  textAlign: "left",
  minWidth: "150px",
});

export const StyledCircularProgress = styled(CircularProgress)({
  color: "#fff",
  marginLeft: "10px",
  fontSize: "small",
});
